import { render, staticRenderFns } from "./StartupsList.vue?vue&type=template&id=3ba6fd0e&scoped=true&"
import script from "./StartupsList.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StartupsList.vue?vue&type=style&index=0&id=3ba6fd0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba6fd0e",
  null
  
)

export default component.exports